module.exports = __webpack_public_path__ + "static/media/p3_3.3fcf3e37.png";